// @flow

import type {
  CartConfigurationNaturalKey,
  PartialOrganization,
  Product,
} from '@gandi/cart';

export function mustCartOwnerBeReseller(
  hasOwnerOnly: boolean,
  cartOwnerList: Array<PartialOrganization>,
): boolean {
  return (
    hasOwnerOnly &&
    cartOwnerList.length === 1 &&
    cartOwnerList.every(orga => orga.reseller)
  );
}

export const resellableCartConfKeys: Array<CartConfigurationNaturalKey> = [
  {
    product_type: 'domain',
    process: 'create',
  },
  {
    product_type: 'domain',
    process: 'transfer',
  },
  {
    product_type: 'certificate',
    process: 'create',
  },
];

export const isProductResellable = ({
  productType,
  process,
}: Product): boolean =>
  resellableCartConfKeys.some(
    cartConfKey =>
      productType === cartConfKey.product_type &&
      process === cartConfKey.process,
  );

export const canChooseProductOwner = ({
  productType,
  process,
}: Product): boolean =>
  (process === 'create' &&
    ['domain', 'paas', 'certificate'].includes(productType)) ||
  (productType === 'cloud' && process === 'add');

export const isProductAutorenewable = ({
  productType,
  process,
}: Product): boolean =>
  (productType === 'domain' && ['create', 'transfer'].includes(process)) ||
  (productType === 'paas' && process === 'create');

export const canChooseProductContacts = ({
  productType,
  process,
}: Product): boolean =>
  productType === 'domain' && ['create', 'transfer'].includes(process);
